import React from 'react'
import { Typography } from '@telavita-core/react-design-kit'

import CheckBox from 'components/CheckBox'

import PortugueseFlagImage from 'static/images/portuguese-flag.png'
import GermanFlagImage from 'static/images/german-flag.png'
import EnglishFlagImage from 'static/images/english-flag.png'
import SpanishFlagImage from 'static/images/spanish-flag.png'
import LibrasImage from 'static/images/libras.png'

import * as S from './styles'

interface Language {
  language: string
}

interface Icon {
  src: string;
  alt: string;
}

interface IconsMap {
  [key: string]: Icon;
}

const languages: Language[] = [
  { language: 'Português' },
  { language: 'Alemão' },
  { language: 'Inglês' },
  { language: 'Libras' },
  { language: 'Espanhol' },
]

const iconsMap: IconsMap = {
  'Português': { src: PortugueseFlagImage, alt: 'bandeira do Brasil' },
  'Alemão': { src: GermanFlagImage, alt: 'bandeira da Alemanha' },
  'Inglês': { src:EnglishFlagImage, alt: 'bandeira dos Estados Unidos' },
  'Libras': { src: LibrasImage, alt: 'ícone de libras' },
  'Espanhol': { src: SpanishFlagImage, alt: 'bandeira da Espanha' },
}

interface ProfessionalLanguageFilterProps {
  selectedLanguages: string[]
  onChangeSelectedLanguages: (languages: string[]) => void
}

export function ProfessionalLanguageFilter({
  selectedLanguages,
  onChangeSelectedLanguages,
}: ProfessionalLanguageFilterProps): JSX.Element {
  
  function handleSelectLanguage(language: string) {
    const isSelectedLanguage = selectedLanguages.some(selectedLanguage => selectedLanguage === language)

    if (isSelectedLanguage) {
      const newLanguages = selectedLanguages.filter(selectedLanguage => selectedLanguage !== language)
      onChangeSelectedLanguages(newLanguages)
    } else {
      const newLanguages = [...selectedLanguages]
      newLanguages.push(language)
      onChangeSelectedLanguages(newLanguages)
    }
  }

  return (
    <S.LanguageContainer>
      <Typography
        variant='content2'
        weight='bold'
      >
        Idioma e acessibilidade
      </Typography>

      <div>
        {languages.map(item => {
          const icon = iconsMap[item.language]

          return (
            <CheckBox
              key={item.language}
              title={
                <S.Title>
                  <img 
                    width={item.language === 'Libras' ? '18px' : '24px'} 
                    src={icon.src} 
                    alt={icon.alt} 
                  />
                  {item.language}
                </S.Title>
              }
              isSelected={selectedLanguages.some(selectedLanguage => selectedLanguage === item.language)}
              onClickCheckBox={() => handleSelectLanguage(item.language)}
              customIconColor={
                selectedLanguages.some(selectedLanguage => selectedLanguage === item.language)
                  ? '#1F35B5'
                  : '#4B4B4B'
              }
              indeterminate={false}
            />
          )
        })}
      </div>
    </S.LanguageContainer>
  )
}